import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.97 4.77c.02.07.03.15.03.23v1c0 1.48-.8 2.77-2 3.46V19c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-5h-2c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1v5h2v-8a3.97 3.97 0 0 1-2.93-1.28C12.36 9.53 11.3 10 10 10a4 4 0 0 1-3-1.36A4 4 0 0 1 4 10c-2.21 0-4-1.79-4-4V5c0-.08.01-.16.03-.23.02-.07.04-.14.08-.21.01-.04.04-.08.06-.12L2.11.55C2.27.21 2.62 0 3 0h14a.988.988 0 0 1 .89.55l1.94 3.89c.02.04.05.08.06.12a.904.904 0 0 1 .08.21zM4 8c1.1 0 2-.9 2-2H2c0 1.1.9 2 2 2zm6 0c.6 0 2-.19 2-2H8c0 1.1.9 2 2 2zM2.62 4h14.76l-1-2H3.62l-1 2zM16 8c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.71 16.71l-3 3c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29-.39-.39-.39-1.03 0-1.42L4.59 17H1c-.55 0-1-.45-1-1s.45-1 1-1h3.59l-1.3-1.29c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l3 3c.39.39.39 1.03 0 1.42z"
});

var SvgImportStoreMajorMonotone = function SvgImportStoreMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgImportStoreMajorMonotone as S };